const defaultMessages = {
  welcome: {
    description: "The welcome msg for the app",
    defaultMessage: "Welcome to the Application Home Page",
    id: "Home.welcome",
  },
  notFound: {
    title: {
      description: "Not found title",
      defaultMessage: "Page not found.",
      id: "notFound.title",
    },
    message: {
      description: "Not found message",
      defaultMessage: "Sorry, we couldn't find the page you requested.",
      id: "notFound.message",
    },
  },
  alreadySubscribeddmp: {
    title: {
      description: "Already subscribed title",
      defaultMessage: "Good news!",
      id: "alreadySubscribed.title",
    },
    message: {
      description: "Already subscribed message",
      defaultMessage:
        "<p>Our records show that you already have an active subscription to DynaMed.</p><p><a href='/store/my-subscription'>Review your subscription details</a> or—if you need further help—please contact us at <a href='mailto:medicalsupport@ebsco.com'>medicalsupport@ebsco.com</a>.</p>",
      id: "alreadySubscribed.message",
    },
  },
  alreadySubscribeddmx: {
    title: {
      description: "Already subscribed title",
      defaultMessage: "Good news!",
      id: "alreadySubscribed.title",
    },
    message: {
      description: "Already subscribed message",
      defaultMessage:
        "<p>Our records show that you already have an active subscription to DynaMedex.</p><p><a href='/store/my-subscription'>Review your subscription details</a> or—if you need further help—please contact us at <a href='mailto:medicalsupport@ebsco.com'>medicalsupport@ebsco.com</a>.</p>",
      id: "alreadySubscribed.message",
    },
  },
  apiDown: {
    title: {
      description: "API down title",
      defaultMessage: "We're sorry, but something went wrong.",
      id: "apiDown.title",
    },
    message: {
      description: "API down message",
      defaultMessage:
        "<p>Please try again and, if the issue persists, contact us at <a href='mailto:medicalsupport@ebsco.com'>medicalsupport@ebsco.com</a></p>",
      id: "apiDown.message",
    },
  },
};

export default defaultMessages;
